/**
 * Created with IntelliJ IDEA.
 * User: raml
 * Date: 7/9/13
 * Time: 10:39 AM
 * This model is an interface for the topLevelMenuItem controller.
 */
define(function (require) {
    "use strict";

    var Backbone = require("backbone");

    // constants

    var TopLevelMenuItemModel = Backbone.Model.extend({
        defaults: {
            title: "",
            description: "",
            callback: function(){
                return false;
            },
            context: this,
            enabled: true,
            iconClass: "",
            isIconRight: null,
            className: "",
            indicatorText: "",
            indicatorClass: ""
        },
        name: "TopLevelMenuItemModel"
    });

    return TopLevelMenuItemModel;
});
